export const selectTotalPipelineData = (state) => state.capture.totalPipeline.data;
export const selectTotalPipelineLoading = (state) =>
  state.capture.totalPipeline.isLoading;
export const selectTotalPipelineError = (state) => state.capture.totalPipeline.error;
